import {
  SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS,
  SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS,
  SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS,
  PUBLISH_STARTS_FOR_TOURNAMENT,
  PUBLISH_ENDS_FOR_TOURNAMENT,
  DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE,
  CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE,
  SET_EXPORT_SYSTEM_INFO,
  LOADING_STARTS_FOR_TOURNAMENT,
  LOADING_ENDS_FOR_TOURNAMENT,
  SET_EXPORT_STATUS
} from './constants';

const initialState = {
  publishing: false,
  statuses: [],
  currentStatus: '',
  hasPendingChanges: false,
  confirmStatusChangeModal: {
    newStatus: '',
    currentStatus: '',
    visible: false
  },
  exportSystemName: '',
  systemShouldExport: false,
  exportStatus: null,
  exportFileLocation: null,
  exportFileName: ""
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) {
    case SET_TOURNAMENT_STATUS_FOR_TOURNAMENT_STATUS:
      return {
        ...state,
        currentStatus: payload || ''
      };
    case SET_TOURNAMENT_HAS_PENDING_CHANGES_FOR_TOURNAMENT_STATUS:
      return {
        ...state,
        hasPendingChanges: payload || false
      };
    case SET_AVAILABLE_STATUSES_FOR_TOURNAMENT_STATUS:
      return {
        ...state,
        statuses: payload || []
      };
    case PUBLISH_STARTS_FOR_TOURNAMENT:
      return {
        ...state,
        publishing: true
      };
    case PUBLISH_ENDS_FOR_TOURNAMENT:
      return {
        ...state,
        publishing: false
      };
    case DISPLAY_CONFIRM_MODAL_FOR_STATUS_CHANGE:
      return {
         ...state,
         confirmStatusChangeModal: {
           ...state.confirmStatusChangeModal,
           newStatus: payload || '',
           currentStatus: state.currentStatus,
           visible: true
         }
       };
    case CANCEL_CONFIRM_MODAL_FOR_STATUS_CHANGE:
      return {
        ...state,
        confirmStatusChangeModal: initialState.confirmStatusChangeModal
      };
    case SET_EXPORT_SYSTEM_INFO:
      return {
        ...state,
        exportSystemName: payload.exportSystemName,
        systemShouldExport: payload.systemShouldExport
      };
    case LOADING_STARTS_FOR_TOURNAMENT:
      return {
        ...state,
        loading: true
      };
    case LOADING_ENDS_FOR_TOURNAMENT:
      return {
        ...state,
        loading: false
      };
    case SET_EXPORT_STATUS:
      return {
        ...state,
        exportStatus: payload.exportStatus,
        exportFileLocation: payload.exportFileLocation,
        exportFileName: payload.exportFileName
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/status/reducer.js